'use client';

import Box from '@enlighten/design-system/dist/Box';
import Button from '@enlighten/design-system/dist/Button';
import Divider from '@enlighten/design-system/dist/Divider';
import Stack from '@enlighten/design-system/dist/Stack';
import Link from 'next/link';
import { usePathname } from 'next/navigation';
import React from 'react';

const MOBILE_TAB_HEIGHT = 110;

export default function Tabs() {
	const pathname = usePathname();
	const value: 'hanwha' | 'egi' = pathname.endsWith('/hanwha') ? 'hanwha' : 'egi';
	const [isMobileVisible, setIsMobileVisible] = React.useState(true);

	React.useEffect(() => {
		setIsMobileVisible(true);
	}, [pathname]);

	React.useEffect(() => {
		let lastScrollY = window.scrollY;

		const handleScroll = () => {
			const currentScrollY = window.scrollY;
			const isScrollingUp = currentScrollY < lastScrollY;
			lastScrollY = currentScrollY;

			setIsMobileVisible(currentScrollY < MOBILE_TAB_HEIGHT || isScrollingUp);
		};

		window.addEventListener('scroll', handleScroll, { passive: true });
		return () => {
			window.removeEventListener('scroll', handleScroll);
		};
	}, []);

	return (
		<Stack
			position="sticky"
			top={{ xs: 64, md: 96 }}
			zIndex={99}
			display="flex"
			direction="row"
			justifyContent="center"
			alignItems="center"
			bgcolor="common.white"
			width="100%"
			boxShadow="0 8px 20px 0 rgba(0, 0, 0, 0.05)"
			sx={{
				opacity: { xs: isMobileVisible ? 1 : 0, md: 1 },
				pointerEvents: { xs: isMobileVisible ? 'auto' : 'none', md: 'auto' },
				transition: 'opacity 0.3s ease',
			}}
		>
			<Stack
				display="grid"
				gridTemplateColumns="1fr 1px 1fr"
				direction="row"
				alignItems="center"
				width="100%"
				maxWidth={1392}
				height={{ xs: MOBILE_TAB_HEIGHT, md: 86 }}
				divider={
					<Divider
						orientation="vertical"
						flexItem
						sx={{
							opacity: 1,
							height: '33%',
							borderWidth: 1,
							borderColor: 'grey.300',
							marginY: 'auto',
						}}
					/>
				}
			>
				<Button
					component={Link}
					href="/insurance/egi"
					variant="text"
					sx={{
						flex: 1,
						fontSize: 22,
						color: value === 'egi' ? 'grey.900' : 'grey.400',
						height: '100%',
						minHeight: 0,
						borderRadius: 0,
						padding: '16px',
						lineHeight: 1.4,
						wordBreak: 'keep-all',
						textAlign: 'center',
						transition: 'all 0.3s ease',
					}}
				>
					EGi 태양광종합공제보험
				</Button>
				<Button
					component={Link}
					href="/insurance/hanwha"
					variant="text"
					sx={{
						flex: 1,
						fontSize: 22,
						color: value === 'hanwha' ? 'grey.900' : 'grey.400',
						height: '100%',
						minHeight: 0,
						borderRadius: 0,
						padding: '16px',
						lineHeight: 1.4,
						wordBreak: 'keep-all',

						transition: 'all 0.3s ease',
					}}
				>
					<Box component="span" display={{ xs: 'none', md: 'block' }}>
						{'한화손보 \u00d7 TPA코리아 태양광발전소종합보험'}
					</Box>
					<Box component="span" display={{ xs: 'block', md: 'none' }} whiteSpace="pre-line" textAlign="center">
						{'한화손보\n\u00d7\nTPA코리아\n태양광발전소종합보험'}
					</Box>
				</Button>
			</Stack>
		</Stack>
	);
}
